import { createIdSlice } from '../utils/action/createElementSlice';
export const PromptHeaderState = createIdSlice({
    elementName: 'prompt-header',
    initialState: {},
    reducers: {
        init(_state, action) {
            return action.payload.data;
        },
        update(state, action) {
            if (!state) {
                return state;
            }
            return Object.assign(Object.assign({}, state), action.payload.data);
        },
        open(state) {
            if (!state)
                return;
            return Object.assign(Object.assign({}, state), { status: 'open' });
        },
        close(state) {
            if (!state)
                return;
            return Object.assign(Object.assign({}, state), { status: 'closed' });
        },
    },
});
